"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BTCTimeUnlock = exports.BTCTimeLockConfig = exports.BTCTimeLock = exports.RGBPPUnlock = exports.Uint16 = exports.ExtraCommitmentData = exports.RGBPPLock = exports.RGBPPConfig = void 0;
// This file is generated by @ckb-lumos/molecule, please do not modify it manually.
/* eslint-disable */
const codec_1 = require("@ckb-lumos/codec");
const customized_1 = require("../customized");
const blockchain_1 = require("./blockchain");
const { array, vector, union, option, struct, table } = codec_1.molecule;
const fallbackBytesCodec = (0, codec_1.createBytesCodec)({
    pack: codec_1.bytes.bytify,
    unpack: codec_1.bytes.hexify,
});
function createFallbackFixedBytesCodec(byteLength) {
    return (0, codec_1.createFixedBytesCodec)({
        pack: codec_1.bytes.bytify,
        unpack: codec_1.bytes.hexify,
        byteLength,
    });
}
const byte = createFallbackFixedBytesCodec(1);
exports.RGBPPConfig = struct({
    btcLcTypeHash: blockchain_1.Byte32,
    btcTimeLockTypeHash: blockchain_1.Byte32,
}, ['btcLcTypeHash', 'btcTimeLockTypeHash']);
exports.RGBPPLock = struct({
    outIndex: customized_1.Uint32,
    btcTxid: blockchain_1.Byte32,
}, ['outIndex', 'btcTxid']);
exports.ExtraCommitmentData = struct({
    inputLen: byte,
    outputLen: byte,
}, ['inputLen', 'outputLen']);
exports.Uint16 = createFallbackFixedBytesCodec(2);
exports.RGBPPUnlock = table({
    version: exports.Uint16,
    extraData: exports.ExtraCommitmentData,
    btcTx: blockchain_1.Bytes,
    btcTxProof: blockchain_1.Bytes,
}, ['version', 'extraData', 'btcTx', 'btcTxProof']);
exports.BTCTimeLock = table({
    lockScript: blockchain_1.Script,
    after: customized_1.Uint32,
    btcTxid: blockchain_1.Byte32,
}, ['lockScript', 'after', 'btcTxid']);
exports.BTCTimeLockConfig = struct({
    btcLcTypeHash: blockchain_1.Byte32,
}, ['btcLcTypeHash']);
exports.BTCTimeUnlock = table({
    btcTxProof: blockchain_1.Bytes,
}, ['btcTxProof']);
